module.exports = __webpack_public_path__ + "static/media/24.06e73a01.jpg";